import { useState, useEffect } from "react";
const DEFAULT_OPTIONS = {
  attributes: true,
  childList: true,
  subtree: true
};
const useMutationObservable = ({ targetEl, cb, options }) => {
  const [observer, setObserver] = useState(null);
  useEffect(() => {
    const obs = new MutationObserver(cb);
    setObserver(obs);
  }, [cb, options, setObserver]);
  useEffect(() => {
    if (!observer || !(targetEl instanceof HTMLElement)) return;
    observer.observe(targetEl, options || DEFAULT_OPTIONS);
    return () => observer && observer.disconnect();
  }, [observer, targetEl, options]);
};
export {
  useMutationObservable
};
